module.exports = __webpack_public_path__ + "static/apexChamberOfCommerce-84e982a0cdc0c5d3fe33f07eefa03a12.png";